import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b2643f"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-center text-white",
  style: {"position":"absolute","bottom":"0","width":"100%","opacity":"50%","z-index":"2"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" FAQ ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("BDE Partenaires")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Conditions Générales d'Utilisation ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Recevoir mes codes de réduction ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Pour recevoir vos codes de réduction, veuillez renseigner votre email ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Vos codes ont été envoyés ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Réinitialiser mes préférences ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Vous vous apprétez à réinitialiser la ville sélectionnée et les offres mémorisées. Cette action est irréversible. ")
const _hoisted_10 = { class: "d-flex" }
const _hoisted_11 = { class: "d-inline-flex flex-grow-1" }

import { Clipboard } from "@capacitor/clipboard";

import { version } from "../../package.json";

import { ComputedRef, defineComponent, inject, ref, watch } from "vue";
import cgu from "!!raw-loader!@/assets/cgu.md";
import BDE from "@/assets/BDE.json";
import FAQ from "@/assets/FAQ.json";
import MarkdownViewer from "@/components/MarkdownViewer.vue";

import { PushNotificationsData } from "../notifications";
import { clearStore } from "../emblem-store";
import { City } from "@emblem/common/lib/cities";
import { getCodes } from "@emblem/api";

import CarouselBackground from "@/components/CarouselBackground.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'About',
  setup(__props) {

const city = inject<ComputedRef<City>>("city")!;

const cityBDE = BDE[city.value];

const email = ref("");
const codesSent = ref(false);
const showSendCodes = city.value === City.GRENOBLE;
const sendingCodes = ref(false);
async function sendCodes() {
  if (showSendCodes) {
    sendingCodes.value = true;
    try {
      await getCodes(city.value, email.value);
      codesSent.value = true;
      sendingCodes.value = false;
    } catch (e) {
      sendingCodes.value = false;
      console.error("failed to send codes", e);
      if ((e as any).message === "Not Found") {
        alert(
          "Impossible de trouver une carte correspondant à ton email\nContacte emblem sur instagram ou facebook."
        );
      } else {
        alert(
          "Une erreur est survenue, veuillez réessayer plus tard.\nContacte emblem sur instagram ou facebook si le problème persiste."
        );
      }
    }
  }
}

defineComponent({
  name: "AboutPage",
});

const getNotificationsSequenceStep = ref(0);
watch(getNotificationsSequenceStep, async (val) => {
  if (val === 4) {
    // show notification sequence
    getNotificationsSequenceStep.value = 0;
    if (PushNotificationsData.token) {
      const token = PushNotificationsData.token;
      await Clipboard.write({
        string: token,
      });
      alert("votre token de notifications a été copié dans le presse papier");
    } else {
      alert("pas de token de notifications");
    }
  }
});
function onBDEClick(bde: string, index: number) {
  if (index === 0 && getNotificationsSequenceStep.value % 2 === 0) {
    getNotificationsSequenceStep.value++;
  }
  if (index === 1 && getNotificationsSequenceStep.value % 2 === 1) {
    getNotificationsSequenceStep.value++;
  }
}

async function reset() {
  await clearStore();
  window.location.reload();
}

return (_ctx: any,_cache: any) => {
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, " v" + _toDisplayString(_unref(version)), 1),
    _createVNode(_component_v_container, {
      id: "about-container",
      class: "fill-height"
    }, {
      default: _withCtx(() => [
        _createVNode(CarouselBackground),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_dialog, null, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_list_item, _mergeProps({
                      class: "about-item my-2",
                      rounded: "",
                      elevation: "2"
                    }, props), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      width: "400px",
                      "max-width": "80vw",
                      "max-height": "80vh"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, { items: _unref(FAQ) }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FAQ), (q, i) => {
                                  return (_openBlock(), _createBlock(_component_v_dialog, { key: i }, {
                                    activator: _withCtx(({ props }) => [
                                      _createVNode(_component_v_list_item, _normalizeProps(_guardReactiveProps(props)), {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(q.q), 1)
                                        ]),
                                        _: 2
                                      }, 1040)
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card, {
                                        width: "400px",
                                        "max-width": "80vw",
                                        "max-height": "80vh"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_card_text, null, {
                                            default: _withCtx(() => [
                                              _createVNode(MarkdownViewer, {
                                                content: q.a
                                              }, null, 8, ["content"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["items"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_dialog, null, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_list_item, _mergeProps({
                      class: "about-item my-2",
                      rounded: "",
                      elevation: "2"
                    }, props), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      width: "400px",
                      "max-width": "80vw",
                      "max-height": "80vh"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(cityBDE), (bde, i) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: i,
                                    onClick: ($event: any) => (onBDEClick(bde, i))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(bde), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_dialog, null, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_list_item, _mergeProps({
                      class: "about-item my-2",
                      rounded: "",
                      elevation: "2"
                    }, props), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                      width: "400px",
                      "max-width": "80vw",
                      "max-height": "80vh"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createVNode(MarkdownViewer, { content: _unref(cgu) }, null, 8, ["content"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                showSendCodes
                  ? (_openBlock(), _createBlock(_component_v_dialog, { key: 0 }, {
                      activator: _withCtx(({ props }) => [
                        _createVNode(_component_v_list_item, _mergeProps({
                          class: "about-item my-2",
                          rounded: "",
                          elevation: "2"
                        }, props), {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, null, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1040)
                      ]),
                      default: _withCtx(({ isActive }) => [
                        _createVNode(_component_v_card, {
                          width: "400px",
                          "max-width": "80vw",
                          "max-height": "80vh"
                        }, {
                          default: _withCtx(() => [
                            (!codesSent.value)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _hoisted_6,
                                      _createVNode(_component_v_text_field, {
                                        modelValue: email.value,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event))
                                      }, null, 8, ["modelValue"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_actions, { class: "align-end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_btn, {
                                        text: "",
                                        onClick: ($event: any) => (isActive.value = false),
                                        color: "error"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { icon: "fas fa-times" })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]),
                                      _createVNode(_component_v_btn, {
                                        text: "",
                                        onClick: sendCodes,
                                        color: "success",
                                        loading: sendingCodes.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { icon: "fas fa-check" })
                                        ]),
                                        _: 1
                                      }, 8, ["loading"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 64))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createVNode(_component_v_card_text, null, {
                                    default: _withCtx(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_v_card_actions, { class: "align-end" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_spacer),
                                      _createVNode(_component_v_btn, {
                                        text: "",
                                        onClick: 
                      () => {
                        isActive.value = false;
                        codesSent.value = false;
                      }
                    ,
                                        color: "success"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, { icon: "fas fa-check" })
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ], 64))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_dialog, null, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_list_item, _mergeProps({
                      class: "about-item my-2",
                      rounded: "",
                      elevation: "2"
                    }, props), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_title, null, {
                          default: _withCtx(() => [
                            _hoisted_8
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_card, {
                      width: "400px",
                      "max-width": "80vw",
                      "max-height": "80vh"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _hoisted_9
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_card_actions, { class: "align-end" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_spacer),
                            _createVNode(_component_v_btn, {
                              text: "",
                              onClick: ($event: any) => (isActive.value = false),
                              color: "error"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "fas fa-times" })
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_v_btn, {
                              text: "",
                              onClick: reset,
                              color: "success"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { icon: "fas fa-check" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_v_btn, {
                      class: "instagram flex-grow-1 mr-1",
                      href: "https://www.instagram.com/emblem_grenoble",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: "fa-brands fa-instagram",
                          color: "white"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "facebook flex-grow-1 ml-1",
                      href: "https://www.facebook.com/emblemgrenoble/",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: "fa-brands fa-facebook-f",
                          color: "white"
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      class: "tiktok flex-grow-1 ml-1",
                      href: "https://www.tiktok.com/@emblem_france",
                      target: "_blank"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, {
                          icon: "fa-brands fa-tiktok",
                          color: "white"
                        })
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})